import type { HITLRendererProps } from '../HITLRenderer';
import { hitlStyles, cn } from './styles';

export const ConfirmationRenderer: React.FC<HITLRendererProps> = ({
  response,
  onSubmit,
  onCancel,
  isSubmitting,
  compact,
}) => {
  const handleConfirm = () => onSubmit('confirm');
  const handleReject = () => {
    if (onCancel) {
      onCancel();
    } else {
      onSubmit('cancel');
    }
  };

  return (
    <div className={compact ? hitlStyles.containerCompact : hitlStyles.container}>
      {response.message && (
        <p className={hitlStyles.message}>{response.message}</p>
      )}
      
      {response.context && (
        <p className={hitlStyles.context}>{response.context}</p>
      )}

      <div className="flex gap-2 mt-3">
        <button
          onClick={handleReject}
          disabled={isSubmitting}
          className={cn(hitlStyles.actionButton, hitlStyles.actionButtonSecondary, 'flex-1')}
        >
          Cancel
        </button>
        <button
          onClick={handleConfirm}
          disabled={isSubmitting}
          className={cn(hitlStyles.actionButton, hitlStyles.actionButtonPrimary, 'flex-1')}
        >
          {isSubmitting ? (
            <span className="flex items-center justify-center gap-2">
              <span className={hitlStyles.spinner} />
              Processing...
            </span>
          ) : (
            'Confirm'
          )}
        </button>
      </div>
    </div>
  );
};

